import { Loader2 } from 'lucide-react'

/**
 * Canonical page/section loading state. One spinner size, one font size,
 * always centered both vertically and horizontally so every page's loading
 * screen looks identical. Use this instead of hand-rolling a spinner + text.
 */
export default function PageLoading({
  label = 'Loading…',
  minHeight = 320,
}: {
  label?: string
  minHeight?: number | string
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        minHeight,
        width: '100%',
        textAlign: 'center',
        color: 'var(--text-tertiary)',
      }}
    >
      <Loader2 size={28} strokeWidth={1.5} style={{ animation: 'spin 1s linear infinite' }} />
      <p style={{ margin: 0, fontSize: 14, color: 'var(--text-tertiary)' }}>{label}</p>
    </div>
  )
}
